export default __webpack_public_path__ + "static/media/topomap_relative_norm.5bf5fba3.webp";